import React from 'react';
import './MainRouting.scss';

import { useSelector } from 'react-redux'; 
import { selectAuth } from '../../redux/slices/authSlice'; 
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import SideNav from '../../components/SideNav/SideNav';
import Navbar from '../../components/Navbar/Navbar';

import Dashboard from '../../pages/Dashboard/Dashboard';
import BlockManagement from '../../pages/BlockManagement/BlockManagement';

import HouseStatus from '../../pages/HouseStatus/HouseStatus';
import HouseDetails from '../../pages/HouseDetails/HouseDetails';
import AddHouseDetails from '../../pages/HouseDetails/AddHouseDetails/AddHouseDetails';

import Report from '../../pages/Report/Report';

import Supervisor from '../../pages/Supervisor/Supervisor';
import SupervisorDetails from '../../pages/Supervisor/SupervisorDetails/SupervisorDetails';
import Year from '../../pages/Year/Year';
import Panchayat from '../../pages/Panchayat/Panchayat';
import Category from '../../pages/Category/Category';
import Village from '../../pages/Village/Village';
import Schemes from '../../pages/Schemes/Schemes';
import Reportview from '../../pages/Report/Reportview';
import Districts from '../../pages/Districts/Districts';
import BlockEmails from '../../pages/BlockEmails/BlockEmails';




const MainRouting = () => {
    const auth = useSelector(selectAuth); 
  
    if (!auth.isAuthenticated) {
      return <Redirect to="/" />;
    }
  
    return (
      <Router>
        <div className='app'>
   
            <div className='sidenav'>
                <SideNav /> 
            </div>

            <div className='main'>
                <div className='main-nav'>  
                    <Navbar /> 
                </div>

                <div className='main-contents'>
                    <Switch>
                        <Route exact path='/' component={Dashboard} />
                        <Route path='/blockmanagement' component={BlockManagement} />
                        <Route path='/housestatus' component={HouseStatus}/>
                        <Route path='/housedetails' component={HouseDetails}/>
                        <Route path='/report' component={Report}/>
                        <Route path='/supervisor' component={Supervisor}/>
                        <Route path='/add-supervisor-details' component={SupervisorDetails}/>
                        <Route path='/add-house-details' component={AddHouseDetails}/>
                        <Route path='/year' component={Year}/>
                        <Route path='/panchayat' component={Panchayat}/>
                        <Route path='/category' component={Category}/>
                        <Route path='/villages' component ={Village}/>
                        <Route path='/report-view/:transactionId' component ={Reportview}/>
                        <Route path= '/schemes'
                        component = {Schemes}/>
                         <Route path= '/districts'
                        component = {Districts}/>
                         <Route path= '/blockEmails'
                        component = {BlockEmails}/>

                        <Redirect to='/' />
                    </Switch>
                </div>
            </div>
            
        </div>
      </Router>
    );
};

export default MainRouting;
